<script>
import {productBiller as columns} from '../../../tables'

export default {
  name: "product-biller-list",
  props: {
    product: {
      type: String,
      required: true
    }
  },
  computed: {
    pageSize() {
      return parseInt(this.items.per_page)
    },
  },
  data() {
    return {
      columns,
      items: {
        loading: true
      },
      filters: {
        page: 1,
        per_page: 10
      }
    }
  },
  created() {
    this.items = {...this.items, ...this.getDefaultPagination()}
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    getItems() {
      this.$http.get(this.routeUri('hyperion.product.biller', {
        product_hash: this.product
      }), { params: this.filters }).then(res => (this.items = {...this.items, ...res.data}))
        .catch(err => this.handleXhrError(err))
        .finally(() => (this.items.loading = false))
    },
    destroy(billerProduct) {
      this.$http.delete(this.routeUri('hyperion.product.biller.destroy', {
        product_hash: this.product,
        biller_product_uuid: billerProduct.id
      })).then(res => this.handleXhrRequest(res.data))
        .catch(err => this.handleXhrError(err))
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleXhrRequest(res) {
      this.$notification.success({
        message: 'Success!',
        description: 'Data has been successfully saved!'
      })
      setTimeout(() => window.location.href = res.data.redirect, 2000)
    }
  }
}
</script>

<template>
  <a-card type="inner" size="small" :loading="items.loading">
    <a-row type="flex" justify="end" class="mb-5">
      <a-button type="default" icon="plus"  :href="routeUri('hyperion.product.biller.create', { product_hash: product })">Create</a-button>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-skeleton :loading="items.loading" active>
          <a-table :data-source="items.data"
                   :columns="columns"
                   rowKey="id"
                   :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
                   @change="tableChanged">
            <div slot="priority" slot-scope="priority">
              <a-icon type="to-top"/>
              <span style="margin-left: 8px; font-weight: bold">{{ priority }}</span>
            </div>

            <h4 slot="biller" slot-scope="record">
              <a-icon type="deployment-unit" /> <a :href="routeUri('hyperion.biller.show', { biller_hash: record.biller.hash })">{{ record.biller.name }}</a>
              <br>
              <a-icon type="gateway" /> <small><code>{{ record.driver }}</code></small>
            </h4>

            <h4 slot="productCode" slot-scope="code">
              <a-icon type="code"></a-icon>
              <code>{{ code }}</code>
            </h4>

            <div slot="classSchema" slot-scope="classSchema">
              <a-icon type="api"/>
              <strong><code>{{ classSchema }}</code></strong>
            </div>

            <h4 slot="priceScheme" slot-scope="price_scheme">
              <code>{{ price_scheme }}</code>
            </h4>

            <h4 slot="basePrice" slot-scope="base_price"><currency :amount="base_price" /></h4>
            <h4 slot="adminFee" slot-scope="admin_fee"><currency :amount="admin_fee" /></h4>
            <h4 slot="shareFee" slot-scope="share_fee"><currency :amount="share_fee" /></h4>

            <div slot="profitable" slot-scope="record">
              <a-tooltip title="Determine the product profitability.">
                <a-tag color="#87d068" v-if="record.is_profitable">YES</a-tag>
                <a-tag color="#f50" v-else>NO</a-tag>
              </a-tooltip>
            </div>

            <div slot="action" slot-scope="record" class="text-right">
              <a-button icon="security-scan" size="small" :href="routeUri('hyperion.product.biller.rule', { product_hash: product, biller_product_uuid: record.id})" />

              <a-button icon="edit" type="primary" size="small" :href="routeUri('hyperion.product.biller.edit', {
                product_hash: product,
                biller_product_uuid: record.id
              })" />

              <a-popconfirm
                title="This will delete connection to this driver, are you sure?"
                @confirm="() => destroy(record)">
                <a-button type="danger" size="small" icon="delete" />
              </a-popconfirm>
            </div>

          </a-table>
        </a-skeleton>
      </a-col>
    </a-row>
  </a-card>
</template>
